export {default as LocationSelectionPage} from "./Page";
